
import forge from 'node-forge'; // libreria que permitira encriptar mensajes
/**
   * Funcion que genera hashing md5
   * @param {string} message - Mensaje que se desea encriptar en formato md5
   * @author Kenzo Sashida 
   * @version 1.0.0 - Diciembre 2024
   */
export  function generateHashing(message) {
    if (!message || typeof message !== 'object') throw new Error("Error al generar hashing: mensaje inválido");
    //definir varaible para realizar el proceso de hashing
    let dataStructure
    //Retorna un listado de cada valor que contenga el objeto mensaje
    dataStructure = Object.values(message)
    // Realizar la estructura requerida para el hashing
    dataStructure= dataStructure.join('|') // Retorna un string cada elemento array sera separado por el caracter '|'
    
    const md5Hash = forge.md.md5.create();
    const hashing = md5Hash.update(`|${dataStructure}|`)
    
    return hashing
}
/**
   * Funcion para firmar hash
   * @param {object} hash - hash realizado previamente por generateHashing
   * @author Kenzo Sashida 
   * @version 1.0.0 - Diciembre 2024
   */
export function signHash(hash){
    if(!hash ) throw new Error("Error al generar hashing.");
    console.log(typeof hash)
    const privateKeyPEM = process.env.REACT_APP_PRIVATE_KEY
    const originalPrivateKey = privateKeyPEM.replace(/\\n/g, '\n')
    const privateKey = forge.pki.privateKeyFromPem(originalPrivateKey)
    const signature = privateKey.sign(hash);
    return forge.util.encode64(signature)
}